import dayjs from "dayjs";
import { KPIItem } from "../../components/Business/StatsKPIGroup";
import { OverdueDashboardSummary, OverdueBillDashboardSummary } from "../../types/entity/overdue";
import _ from 'lodash';

export const getKpiStatic = (stats: OverdueDashboardSummary): KPIItem[] => {
  if (!stats) return [];

  return [
    { title: '逾期中订单数', value: stats.overduingOrdersTotal || 0 },
    { title: '逾期中金额', value: _.round(stats.overduingAmount || 0, 2) },
    { title: '逾期未处理订单比例', value: stats?.unhandledOrderRate ? _.round(stats.unhandledOrderRate, 2) : 0, suffix: '%' },
    { title: '逾期未处理期数比例', value: stats?.unhandledInstallmentRate ? _.round(stats.unhandledInstallmentRate, 2) : 0, suffix: '%' },
    { title: '平均逾期天数', value: _.round(stats.overduingAverageDays || 0, 2) },
  ]
}

export const getBillKpiStatic = (stats: OverdueBillDashboardSummary): KPIItem[] => {
  if (!stats) return [];

  return [
    { title: '逾期中账单数', value: stats.overduingBillCount || 0 },
    { title: '逾期中金额', value: _.round(stats.overduingAmount || 0, 2), prefix: '¥' },
    { title: '逾期未处理账单比例', value: stats.unhandledBillRate ? _.round(stats.unhandledBillRate, 2) : 0, suffix: '%' },
    { title: '预计坏账总金额', value: _.round(stats.estimatedBadDebtAmount || 0, 2), prefix: '¥' },
    { title: '平均逾期天数', value: _.round(stats.averageOverdueDays || 0, 2), suffix: '天' },
  ]
}

export const getDefaultQuery = (appendQuery?: any, group?: string) => {
  const today = dayjs().startOf('day');
  const weekStart = '2024-12-20';
  const weekEnd = today.subtract(1, 'day').format('YYYY-MM-DD');
  let baseFilter: any = { orderCreatedAt: { operator: 'between', value: [weekStart, weekEnd] } };
  if (group) {
    baseFilter = { [group]: baseFilter };
  }
  return { filter:  { 
      ...baseFilter,
      ...appendQuery 
    }
  } as any
};
